import { Container } from "@ruter-as/web-components-and-tools";
import type React from "react";
import { type PropsWithChildren, useEffect } from "react";
import { NavLink } from "react-router";
import { getEnv, getTenant } from "../../env";
import AktLogo from "../../gfx/akt-logo";
import RuterLogo from "../../gfx/ruterbedrift-logo";
import type { Company } from "../../types/Company";
import { useAuthenticatedAuthContext } from "../auth/Auth.component";
import "./LinkWrapper.scss";

interface Props {
	selectedCompany: Company | undefined;
}

const LinkWrapper: React.FC<PropsWithChildren<Props>> = ({
	selectedCompany,
	children,
}) => {
	const env = getEnv();
	const context = useAuthenticatedAuthContext();

	const showNewInfoPage = context.selectedCompany.availableSubscriptions.some(
		(x) =>
			x.type === "JOULE" ||
			x.type === "CAR_POOL" ||
			x.type === "TRAVEL_SUBSCRIPTION",
	);
	useEffect(() => {
		document.body.style.backgroundColor = "#F4F2F1";
	});

	const renderInfoButton = (): React.JSX.Element => {
		if (getTenant() === "akt") {
			return (
				<NavLink
					to="https://www.akt.no/bedrift/akt-bedrift-info/bedriftsrelaterte-billetter/akt-bedrift-billetten/"
					data-test-id="akt-info-button"
					target="_blank"
				>
					Info
				</NavLink>
			);
		}
		if (showNewInfoPage) {
			return (
				<NavLink
					to="/info/abonnement"
					data-test-id="electric-bike-info-button"
					className={({ isActive }) => (isActive ? "selected" : undefined)}
				>
					Info
				</NavLink>
			);
		}

		return (
			<NavLink
				to="/info/bedriftsbillett"
				data-test-id="company-ticket-info-button"
				className={({ isActive }) => (isActive ? "selected" : undefined)}
			>
				Info
			</NavLink>
		);
	};

	return (
		<div className="link-wrapper">
			<div className="top-menu" data-test-id="top-menu">
				<Container width="xxl">
					<div className="logo">
						{env.tenant === "ruter" && <RuterLogo />}
						{env.tenant === "akt" && (
							<div className="akt-logo">
								<AktLogo />
							</div>
						)}
					</div>
					<div className="company-name" data-test-id="company-name">
						{selectedCompany?.name}
					</div>
				</Container>
			</div>
			<div className="sub-menu">
				<Container width="s">
					<NavLink
						to="/abonnement"
						data-test-id="order-button"
						className={({ isActive }) => (isActive ? "selected" : undefined)}
					>
						Abonnement
					</NavLink>
					{renderInfoButton()}
				</Container>
			</div>
			<div className="content">
				<Container width="s">{children}</Container>
			</div>
		</div>
	);
};

export default LinkWrapper;
